import { render } from "./CompoAPIreactive.vue?vue&type=template&id=5af8748a&scoped=true"
import script from "./CompoAPIreactive.vue?vue&type=script&lang=js"
export * from "./CompoAPIreactive.vue?vue&type=script&lang=js"

import "./CompoAPIreactive.vue?vue&type=style&index=0&id=5af8748a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af8748a"]])

export default __exports__